import { AnnotationButton } from "components/annotations/AnnotationButton";
import { ReactNode } from "react";
import styles from "../aic.module.css";
import { AitAddRowGroupButton } from "./AitAddRowGroupButton";
import { AitRemoveRowGroupButton } from "./AitRemoveRowGroupButton";
import { AitRowGroupOptionsButton } from "./AitRowGroupOptionsButton";
import { AitRowGroupOptionsWindow } from "./AitRowGroupOptionsWindow";
import { AitLocationBodyRowGroup } from "./functions/interface";
import { trGetPositionFromLocation } from "./functions/trGetPositionFromLocation";
import { useTableContext } from "./TableContextProvider";

interface AitRowGroupButtonsProps {
  location: AitLocationBodyRowGroup;
}

/**
 * Row-group level buttons (annotation and group controls).
 *
 * @param props - Component props
 * @param props.location - The row group location
 */
export const AitRowGroupButtons = ({ location }: AitRowGroupButtonsProps): ReactNode => {
  const { state } = useTableContext();
  const thisRowGroup = trGetPositionFromLocation(state, location, true).data;
  const showAnnotation = state?.tlfViewMode.value === "ANNOTATIONS";

  return (
    <div className={styles.aitAieHolder}>
      <AnnotationButton
        buttonId={`${location.position}-rowgroup-${location.rowGroupId}-annotation`}
        annotationType="RowGroup"
        annotationLocation={location}
        existingAnnotation={thisRowGroup?.annotation}
        hidden={!showAnnotation}
        showPreview={showAnnotation}
      />
      <div className={[styles.aitRowGroupButtons, styles.flexRowEnd].join(" ")}>
        <AitRemoveRowGroupButton location={location} />
        <AitAddRowGroupButton location={location} />
        <AitRowGroupOptionsButton location={location} />
        <AitRowGroupOptionsWindow location={location} />
      </div>
    </div>
  );
};

AitRowGroupButtons.displayName = "AitRowGroupButtons";
